import AppPaths from './paths'
import { useCurrentMember } from './useCurrentMember'

/**
 * Determines the correct app path to navigate to a user profile page.
 * If the logged in member's id matches the requested member id, it will return
 * a route to the 'Me' page, otherwise, returns a route to the 'Profile' page
 * @param memberId (string) uuid of the selected member
 * @returns (string) route to either the 'Me' or 'Profile' page
 *
 * Note: yes, I know this is hacky. Once we have solidified requirements
 * around how to handle these pages, hopefully someone can come up with a more
 * elegant solution. If you are reading this, this could be you!
 */
const useMemberProfileRoute = () => {
  const { member } = useCurrentMember()

  const getMemberProfileRoute = (memberId: string) =>
    member?.id === memberId ? AppPaths.tenant.me() : AppPaths.tenant.memberProfile(memberId)

  return getMemberProfileRoute
}

// eslint-disable-next-line local/require-with-app-permission-for-routes
export default useMemberProfileRoute
